import { Box, Dialog, DialogContent, DialogTitle, Grid, makeStyles, Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Typography } from '@material-ui/core'
import moment from 'moment'
import React from 'react'
import CloseIcon from "@material-ui/icons/Close";

const useStyles = makeStyles(() => ({
  borders: {
    border: '2px solid #707070',
    display: 'flex',
    width: '1.6rem',
    backgroundColor: 'grey',
  },
  title: {
    fontWeight: 500,
    fontSize: '1.5rem',
    textAlign: 'left',
    paddingBottom: '0.3rem',
  },
  tableContainer: {
    maxHeight: 400, // Scrollable height
    overflowX: "auto",
  },
  stickyHeader: {
    position: "sticky",
    left: 0,
    background: "#fff",
    zIndex: 200,
    minWidth: 120,
    height: "56px",
  },
  stickyHeader2: {
    position: "sticky",
    left: 120,
    background: "#fff",
    zIndex: 200,
    minWidth: 250,
    height: "56px",
  },
  stickyHeader3: {
    position: "sticky",
    left: 370,
    background: "#fff",
    zIndex: 200,
    minWidth: 150,
    height: "56px",
  },
  stickyColumn: {
    position: "sticky",
    left: 0,
    background: "#fff",
    zIndex: 100,
    minWidth: 120,
    overflowWrap: "break-word",
  },
  stickyColumn2: {
    position: "sticky",
    left: 120,
    background: "#fff",
    zIndex: 100,
    minWidth: 250,
    overflowWrap: "break-word",
  },
  stickyColumn3: {
    position: "sticky",
    left: 370,
    background: "#fff",
    zIndex: 100,
    minWidth: 150,
    overflowWrap: "break-word",
  },
  headerCell: {
    backgroundColor: "#eee",
    fontWeight: "bold",
    // textAlign: "center",
    whiteSpace: "nowrap",
      height: "28px",
    padding:'10px'
  },
  groupedHeader: {
    backgroundColor: "#eee",
    fontWeight: "bold",
    textAlign: "center",
    whiteSpace: "nowrap",
    height: "28px",
    position: "sticky",
    padding:'10px',
    top: 0,
      zIndex: 3,
    border: 'none',
    paddingBottom:'0px'
  },  
}));

const ViewASNDetails = ({openASN,setOpenASN,rowInfo}) => {
    const classes = useStyles();
  return (
    <div>
      <Dialog
        open={openASN}
        onClose={() => setOpenASN(false)}
        maxWidth='md'
        fullWidth
      >
        <Box
          display='flex'
          justifyContent='flex-end'
          alignItems='center'
          mb={2}
        >
          <Grid item xs={2}>
            <Typography
              variant='body2'
              style={{
                display: "flex",
                alignItems: "center",
                position: "absolute",
                top: "12px",
                right: "10px",
                cursor: "pointer",
                fontWeight: 600,
              }}
              onClick={() => setOpenASN(false)}
            >
              Cancel{" "}
              <CloseIcon style={{ fontSize: "35px", color: "#FF0000" }} />
            </Typography>
          </Grid>
        </Box>
        <DialogTitle style={{ textAlign: "center" }}>
          <Typography
            variant='body2'
            style={{ fontSize: "2rem", fontWeight: 550, color: "black" }}
          >
            View ASN Details
          </Typography>
        </DialogTitle>
        <DialogContent>

          <TableContainer component={Paper} style={{ backgroundColor: "#f2f8fb" }}>
          <Table>
            <TableHead>
              <TableRow>
                <TableCell>Sponsor</TableCell>
                <TableCell>CMO</TableCell>
                <TableCell>Plant ID</TableCell>
                <TableCell>PO number</TableCell>
                <TableCell>Product Code/Description</TableCell>
                <TableCell>Batch Number</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              <TableRow>
                <TableCell>{rowInfo?.scheduleLineDetails?.sponsorName || "NA"}</TableCell>
                <TableCell>{rowInfo?.scheduleLineDetails?.vendorName || "NA"}</TableCell>
                <TableCell>{rowInfo?.scheduleLineDetails?.vendorPlant || "NA"}</TableCell>
                <TableCell>{rowInfo?.scheduleLineDetails?.scheduleAgreementNumber}</TableCell>
                <TableCell>{`${rowInfo?.scheduleLineDetails?.fgMaterialCode} / ${rowInfo?.scheduleLineDetails?.fgMaterialName}`}</TableCell>
                <TableCell>{rowInfo?.batchDetails?.vendorBatchNumber || "NA"}</TableCell>
              </TableRow>
            </TableBody>
          </Table>
        </TableContainer>

        <TableContainer component={Paper} style={{ backgroundColor: "#f2f8fb", marginTop: "1rem" }}>
          <Table>
            <TableHead>
              <TableRow>
                <TableCell>Pickup Address</TableCell>
                <TableCell>Delivery Address</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              <TableRow>
                <TableCell>
                  {rowInfo?.scheduleLineDetails?.pickupAddress?.street_address_1}, {rowInfo?.scheduleLineDetails?.pickupAddress?.street_address_2}
                </TableCell>
                <TableCell>
                  {rowInfo?.scheduleLineDetails?.deliveryAddress?.street_address_1}, {rowInfo?.scheduleLineDetails?.deliveryAddress?.street_address_2}
                </TableCell>
              </TableRow>
            </TableBody>
          </Table>
        </TableContainer>

                  <Grid item xs={12} sm={12} md={12} style={{marginTop:"1rem"}}>
                    <Typography variant="h4" className={classes.title}>
                      Shipping Information
                    </Typography>
                    <span className={classes.borders}></span>
                  </Grid>

        <TableContainer style={{ border: "none", marginTop: "1rem" }}>
          <Table>
            <TableBody>
              <TableRow>
                <TableCell style={{ border: "none",fontWeight:550}}>Dispatch Quantity</TableCell>
                <TableCell style={{ border: "none",fontWeight:550 }}>Dispatch Quantity UOM</TableCell>
              </TableRow>
              <TableRow>
                <TableCell style={{ border: "none" }}>{rowInfo?.batchDetails?.dispatchQuantity || "NA"}</TableCell>
                <TableCell style={{ border: "none" }}>{rowInfo?.batchDetails?.batchUOM || "NA"}</TableCell>
              </TableRow>
              <TableRow>
                <TableCell style={{ border: "none",fontWeight:550 }}>Dispatch Date</TableCell>
                <TableCell style={{ border: "none",fontWeight:550 }}>Shipper Name</TableCell>
                <TableCell style={{ border: "none",fontWeight:550 }}>Shipment ID</TableCell>
              </TableRow>
              <TableRow>
                <TableCell style={{ border: "none" }}>{moment(rowInfo?.batchDetails?.dispatchDate).format("DD-MMM-YYYY").toUpperCase()}</TableCell>
                <TableCell style={{ border: "none" }}>{rowInfo?.batchDetails?.shipperName || "NA"}</TableCell>
                <TableCell style={{ border: "none" }}>{rowInfo?.batchDetails?.shipmentID || "NA"}</TableCell>
              </TableRow>
              <TableRow>
                <TableCell style={{ border: "none",fontWeight:550 }}>Expected Delivery Date</TableCell>
                <TableCell style={{ border: "none",fontWeight:550 }}>ASN Number</TableCell>
              </TableRow>
              <TableRow>
                <TableCell style={{ border: "none" }}>{moment(rowInfo?.batchDetails?.expectedDeliveryDate).format("DD-MMM-YYYY").toUpperCase()}</TableCell>
                <TableCell style={{ border: "none" }}>{rowInfo?.batchDetails?.asnNumber || "NA"}</TableCell>
              </TableRow>
            </TableBody>
          </Table>
        </TableContainer>
        </DialogContent>
      </Dialog>
    </div>
  )
}

export default ViewASNDetails
